// Dichiarazione globale per fbq
declare var fbq: Function;

export const emitRegistrationCompletedEvent = () => {
    fbq('track', 'CompleteRegistration');
}